module.exports = __webpack_public_path__ + "img/diffuse-480-60.5ae26c2a.jpg";